const firebaseConfig = {
	apiKey: 'AIzaSyBOf-uRpkYSSwUUz1VS9exMfY2sp3dyDP8',
	authDomain: 'dientudl-3dcf8.firebaseapp.com',
	projectId: 'dientudl-3dcf8',
	storageBucket: 'dientudl-3dcf8.firebasestorage.app',
	messagingSenderId: '932977622006',
	appId: '1:932977622006:web:f23986c06487fba6c0a5d7',
	measurementId: 'G-YRZNB2ES2R',
};

export default firebaseConfig;
